export default "__VITE_ASSET__vOmeZVM$__"